import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from 'Utils/Interceptor';
import { useDispatch, useSelector } from 'react-redux';
import { setLoader } from '../../Redux/features/LoaderSlice';
import { toast } from 'react-toastify';
import { setCartData } from '../../Redux/features/ParsistAPIsData';

export default function LocationChangedDialog({
  open,
  handleSetLocation,
  handleClose
}) {
  const dispatch = useDispatch();
  const { cityId } = useSelector((state) => state.location);

  const handleCancel = () => {
    handleClose();
    return;
  };

  const removeCart = async () => {
    dispatch(setLoader(true));
    try {
      await axiosInstance(`/api/user/removecart`);
      const response = await axiosInstance.get(
        `/api/user/mycart?city_id=${cityId}`
      );
      dispatch(setCartData(response.data?.data));

      handleSetLocation();
    } catch (error) {
      dispatch(setLoader(false));
      toast.error(error?.data?.error?.message, {});
      return;
    }
    dispatch(setLoader(false));
  };

  const handleOk = () => {
    removeCart();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <h4>{'Location Changed'}</h4>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <p>
            {' '}
            The cart items are not matching with the current location/modified
            location so please update the location based on the cart selection
            or else the cart will be truncated and again the
            test/health-packages need to be added{' '}
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk}>Ok</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
